import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/internal/Observable';
import { catchError } from 'rxjs/internal/operators/catchError';
import { CommonService } from 'src/app/shared/services/common-service';
import { ReturnStruct } from 'src/app/shared/structs/return.struct';
import { AppConfigService } from 'src/app/app-config.service';
import { EndpointBuilderService } from 'src/app/shared/services/endpint-builder.service';
import { ApiEnum } from 'src/app/shared/enum/api.enum';
import { SelfTriageProtocolRequest } from '../../requests/self-triage/self-triage-protocol.request';
import { ListSelfTriageProtocolResponse } from '../../responses/self-triage/list-self-triage-protocol.response';
import { SelfTriageProtocolResponse } from '../../responses/self-triage/self-triage-protocol.response';

@Injectable({
  providedIn: 'root'
})
export class SelfTriageProtocolService extends CommonService {

  constructor(private router: Router, private httpClient: HttpClient, configService: AppConfigService, private endpointBuilder: EndpointBuilderService) {
    super(configService);
  }

  listProtocol(searchText: string, idHealthUnit: number): Observable<ListSelfTriageProtocolResponse> {

    let uri = `Protocol/GetAll?`

    if (searchText) {
      uri = uri + `searchText=${searchText}&`
    }

    if (idHealthUnit) {
      uri = uri + `idHealthUnit=${idHealthUnit}`;
    }

    return this.httpClient.get<ListSelfTriageProtocolResponse>(this.endpointBuilder.getEndpoint(ApiEnum.urlApiSelfTriage) + uri, this.addHeaderToken())
      .pipe(
        catchError(this.handleError)
      )
  }

  getProtocol(idProtocol: number): Observable<SelfTriageProtocolResponse> {

    let uri = `Protocol/idProtocol/${idProtocol}`

    return this.httpClient.get<SelfTriageProtocolResponse>(this.endpointBuilder.getEndpoint(ApiEnum.urlApiSelfTriage) + uri, this.addHeaderToken())
      .pipe(
        catchError(this.handleError)
      )
  }

  createProtocol(request: SelfTriageProtocolRequest): Observable<ReturnStruct> {
    let uri = `Protocol`

    return this.httpClient.post<ReturnStruct>(this.endpointBuilder.getEndpoint(ApiEnum.urlApiSelfTriage) + uri, request, this.addHeaderToken())
      .pipe(
        catchError(this.handleError)
      )
  }

  updateProtocol(request: SelfTriageProtocolRequest, idProtocol: number): Observable<ReturnStruct> {
    let uri = `Protocol/idProtocol/${idProtocol}`

    return this.httpClient.put<ReturnStruct>(this.endpointBuilder.getEndpoint(ApiEnum.urlApiSelfTriage) + uri, request, this.addHeaderToken())
      .pipe(
        catchError(this.handleError)
      )
  }

  deleteProtocol(idProtocol: number): Observable<ReturnStruct> {
    let uri = `Protocol/idProtocol/${idProtocol}`

    return this.httpClient.delete<ReturnStruct>(this.endpointBuilder.getEndpoint(ApiEnum.urlApiSelfTriage) + uri, this.addHeaderToken())
      .pipe(
        catchError(this.handleError)
      )
  }
}
